export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { isLoggedIn } = useAgsUser()
  const { tryTriggerSync, SYNC_INTERVAL_MS } = useCustomerSync()

  let periodicSyncInterval: NodeJS.Timeout | null = null
  let hasTriggeredPageLoad = false

  if (import.meta.client && !hasTriggeredPageLoad) {
    nextTick(() => {
      if (isLoggedIn.value) {
        tryTriggerSync()
        hasTriggeredPageLoad = true
      }
    })
  }

  router.afterEach((to, from) => {
    if (isLoggedIn.value && to.path !== from.path) {
      tryTriggerSync()
    }
  })

  watch(
    isLoggedIn,
    (loggedIn) => {
      if (loggedIn) {
        if (periodicSyncInterval) {
          clearInterval(periodicSyncInterval)
        }

        periodicSyncInterval = setInterval(() => {
          if (isLoggedIn.value) {
            tryTriggerSync()
          } else {
            if (periodicSyncInterval) {
              clearInterval(periodicSyncInterval)
            }
            periodicSyncInterval = null
          }
        }, SYNC_INTERVAL_MS)
      } else {
        if (periodicSyncInterval) {
          clearInterval(periodicSyncInterval)
        }
        periodicSyncInterval = null
      }
    },
    { immediate: true },
  )
})
